import React from 'react'

const OverlayLimitations = () => (
  <div className='br-upload-limitations'>
    <h4>OVERLAY GUIDELINES:</h4>
    <div>
      <h4 className='caption-subject bold font-green-haze uppercase overlay-headers'>
        IMAGE OVERLAY
      </h4>
      <ul>
        <li>Use a PNG with transparency.</li>
        <li>
          Overlay image dimensions should be equal to or less than 400px x 400px
          as that is the max size of the profile picture.
        </li>
      </ul>
    </div>
    <h4 className='caption-subject bold font-green-haze uppercase overlay-headers'>
      GIF OVERLAY
    </h4>
    <ul>
      <li>GIF must be 70 - 90 frames & GIF file size less than 1mb.</li>
      <li>Combined image has to be less than 15mb.</li>
      <li>
        Dimensions less than 400px x 400px as that is the max size of the
        profile pic.
      </li>
    </ul>
  </div>
)

export default OverlayLimitations



// WEBPACK FOOTER //
// ./src/pages/widgets/form/media-upload/limitations/overlay.js